import apiClient from './client';

// Get all templates (Unified from MessageTemplate table)
export const getTemplates = async (status = null) => {
  try {
    const url = status ? `/templates/?status=${status}` : '/templates/';
    const response = await apiClient.get(url);
    return response.data?.results ?? response.data ?? [];
  } catch (err) {
    console.error("Error fetching templates:", err);
    return [];
  }
};

export const sendCampaign = async (payload) => {
  const response = await apiClient.post('/campaigns/send/', payload);
  return response.data;
};

// Get synced Meta/Flask WhatsApp templates (Now points to same table)
export const getWhatsAppTemplates = async () => {
  const response = await apiClient.get('/whatsapp-templates/');
  return response.data?.results ?? response.data ?? [];
};

// Get template by ID
export const getTemplate = async (templateId) => {
  const response = await apiClient.get(`/templates/${templateId}/`);
  return response.data;
};

export const getWhatsAppTemplate = async (templateId) => {
  const response = await apiClient.get(`/whatsapp-templates/${templateId}/`);
  return response.data;
};

export const sendWhatsAppTemplate = async (payload) => {
  const isFormData = payload instanceof FormData;
  // For FormData, let axios handle the Content-Type header automatically
  // It will set it to multipart/form-data with the correct boundary
  const config = isFormData ? { headers: { 'Content-Type': undefined } } : {};
  const response = await apiClient.post('/whatsapp/send-template/', payload, config);
  return response.data;
};

// Create new WhatsApp template
export const createWhatsAppTemplate = async (payload) => {
  const response = await apiClient.post('/whatsapp-templates/', payload);
  return response.data;
};

// Update WhatsApp template
export const updateWhatsAppTemplate = async (templateId, payload) => {
  const response = await apiClient.patch(`/whatsapp-templates/${templateId}/`, payload);
  return response.data;
};

// Delete WhatsApp template
export const deleteWhatsAppTemplate = async (templateId) => {
  const response = await apiClient.delete(`/whatsapp-templates/${templateId}/`);
  return response.data;
};

// Create new template (Legacy/General)
export const createTemplate = async (payload) => {
  const response = await apiClient.post('/templates/', payload);
  return response.data;
};

// Approve template
export const approveTemplate = async (templateId) => {
  const response = await apiClient.patch(`/templates/${templateId}/approve/`);
  return response.data;
};

// Reject template
export const rejectTemplate = async (templateId) => {
  const response = await apiClient.patch(`/templates/${templateId}/reject/`);
  return response.data;
};

// Sync templates from WhatsApp/Flask. Backend downloads + base64-encodes header media for every
// templates with an image/video header, one request at a time - can legitimately take well past
// the client's default 15s timeout once there are more than a couple of media templates.
export const syncWhatsAppTemplates = async () => {
  const response = await apiClient.post('/whatsapp/templates/sync/', null, { timeout: 120000 });
  return response.data;
};
